<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Пользователь отклонил Вашу заявку в
    a(:href="$router.resolve({ name: 'contacts' }).href")  контакты
</template>

<script>
export default {
  name: 'NotificationContactRequestDeclined',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
